<template>
    <div class="content">
        <div class="header">{{l10nMasechtotHashas}}</div>
        <div class="sub-header">{{l10nCategoryHeading}}</div>
        <div class="divider"></div>
        <div class="categories-content">
            <div class="seder-section" v-for="seder in sedarim" :key="seder.id">
                <div class="seder-header">
                    <div class="seder-header-title">{{l10nSeder}} {{seder.name}}</div>
                    <div class="seder-header-description">{{seder.description}}</div>
                </div>
                <seder-divider :hex-code="seder.color"></seder-divider>
                <div class="seder-body">
                    <category-card v-for="masechet in filterMasechtotBySeder(seder)" :masechet="masechet"
                                   :key="masechet.id" :seder="seder">
                    </category-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SederDivider from './SederDivider'
    import CategoryCard from './CategoryCard'
    import helpers from '../services/helpers'

    export default {
        name: 'categories-component',
        components: {
            'seder-divider': SederDivider,
            'category-card': CategoryCard,
        },
        data: function () {
            return {
                hoverIndex: -1,
            }
        },
        computed: {
            sedarim() {
                return this.$store.state.sedarim.data
            },
            masechtot() {
                return this.$store.state.masechtot.data
            },
            l10nMasechtotHashas() {
                return this.l10nGetter('masechtot_hashas')
            },
            l10nCategoryHeading() {
                return this.l10nGetter('category_heading')
            },
            l10nSeder() {
                return this.l10nGetter('seder')
            },
        },
        methods: {
            filterMasechtotBySeder: function (seder) {
                return this.masechtot.filter(masechet => {
                    return masechet.seder.id === seder.id
                })
            },
            navigateToSubComponent: function (masechet) {
                this.$router.push({name: 'subcategory', params: {id: masechet.id.toString()}})
            },
            navigateToSponsorMasechet: function (masechet) {
                this.$router.push({
                    name: 'dedicationMasechet',
                    // params: {id: masechet.id.toString()}
                })
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },

        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        background: $background-color-grey;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 70px 1em 130px;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .sub-header {
        @include font-abraham(36px, $font-color-blue, 300);
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .categories-content {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
    }

    .seder-section {
        max-width: 1400px;
        width: 100%;

        .seder-header {
            display: flex;
            align-items: baseline;
        }
    }

    .seder-header-title {
        @include font-abraham(30px, $font-color-blue, 400);
        text-transform: uppercase;
        line-height: 50px;
        margin: 0 24px 0 0;
    }

    .seder-header-description {
        @include font-abraham(18px, $font-color-blue, 300);
        line-height: 19px;
    }

    .seder-body {
        padding: 0 0 75px;

        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .masechet-card {
        cursor: pointer;
        background-color: #ffffff;
        box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.17);
        border-left-style: solid;
        border-left-width: 1px;
        margin: 27px 23px 0 0;
        width: 219px;
        $card-height: 260px;
        $main-section-padding: 25px;
        $card-footer-height: 60px;
        height: $card-height;
        .main-section {
            height: $card-height - $main-section-padding * 2 - $card-footer-height;
            text-align: center;
            padding: $main-section-padding 20px;
            .masechet-title {
                @include font-abraham(36px, $font-color-blue, 400);
                line-height: 58.129px;
            }
            .masechet-description {
                @include font-abraham(16px, $grey-1, 400);
                line-height: 19px;
            }

            .hover-div {
                display: none;
                flex-direction: column;
                justify-content: center;
                height: 100%;
            }
            .masechtot-count {
                @include font-abraham(30px, white, 400);
                line-height: 58.129px;
            }

        }
        .footer {
            $footer-background-color: rgba(220, 233, 239, 0.4);
            $footer-padding: 10px;
            height: $card-footer-height - $footer-padding * 2;
            background-color: $footer-background-color;
            @include font-abraham(11px, $font-color-lighter-blue, 400);
            line-height: 14px;
            text-align: center;
            padding: 10px 0;

            .no-sponsor {
                @include font-abraham(12px, $grey-1, 400);
                line-height: 19px;
                text-decoration: underline;
            }
        }

        &:hover {
            background-color: rgba(32, 58, 139, 0.97);
            .not-hover-div {
                display: none;
            }
            .hover-div {
                display: flex;
            }

            .footer {
                color: white;
            }

            .no-sponsor {
                color: white;
            }
        }
    }
</style>
